<div class="sz-spectrum" [class.sz-spectrum--sm]="size() === 'sm'" [class.sz-spectrum--tall]="size() === 'tall'">
  @for (bar of bars(); track $index) {
    <div
      class="sz-spectrum__bar"
      [class.sz-spectrum__bar--on]="bar.kind === 'on'"
      [class.sz-spectrum__bar--best]="bar.kind === 'best'"
      [style.height]="height(bar.value)"></div>
  }
  @if (bestEverBottom(); as bottom) {
    <div class="sz-spectrum__best-line" [style.bottom]="bottom">
      @if (bestEverLabel(); as label) {
        <span class="sz-spectrum__best-tag">{{ label }}</span>
      }
    </div>
  }
</div>
